import React, { useState, useRef, useEffect } from 'react';
import { Sheet, SheetTrigger, SheetContent, SheetHeader, SheetFooter, SheetSlot } from "@/components/templates/sheet";
import { Button } from '@/components/molecules/buttons/button';
import { AddRounded, Paid } from '@mui/icons-material';
import FormEditBills from './FormEditBills';
import { useAddInvoice } from '@/services/admin-services/mutations/useAddConsultantInvoice';
import PrintErrorMessage from '@/components/organisms/feedback/PrintErrorMessage';

export default function AddInvoicePanel({ global=false , refetch = () => {}}) {
    const submitRef = useRef(null);
    const [openAddInvoice, setOpenAddInvoice] = useState(false);
    const [submissionError, setSubmissionError] = useState(false);
    const [submissionSuccess, setSubmissionSuccess] = useState(false);

    const { addInvoice, loading: loadingAdd, error: errorAdd, data: dataAdd } = useAddInvoice();

    const handleSubmit = async (formData) => {
        try {
            setSubmissionError(null);
            setSubmissionSuccess(false);

            const newInvoice = {
                consultantUuid: formData.consultantUuid,
                invoiceDate: formData.invoiceDate,
                periodEnd: formData.periodEnd,
                periodStart: formData.periodStart,
                paymentDate: formData.paymentDate || undefined, // ajout du champ paymentDate
                invoiceNumber: formData.billNumber,
                clientName: formData.customer,
                daysWorked: parseFloat(formData.days),
                dailyRateConsultant: parseFloat(formData.tJMConsultant),
                dailyRateClient: parseFloat(formData.tJMClient),
                currency: formData.currency,
                commission: parseFloat(formData.commission),
                manualCommission: formData.manualCommission || parseFloat(formData?.commission) !== 0,
            };

            await addInvoice({
                variables: { newInvoice },
            });

            setSubmissionSuccess(true);
        } catch (err) {
            setSubmissionError(err.message);
            console.error("Error during submission:", err);
        }
    };

    const handleClose = (close) => {
        setSubmissionError(null);
        setSubmissionSuccess(null);
        setOpenAddInvoice(close);
    };

    useEffect(() => {
        if(submissionSuccess) {
            refetch();
            setOpenAddInvoice(false);
            setSubmissionSuccess(false);
        }
    }, [submissionSuccess]);

    return (
        <Sheet open={openAddInvoice} onOpenChange={handleClose}>
            <SheetTrigger asChild className={global ? `w-full` : undefined}>
                <Button leftIcon={<AddRounded />} showLeftIcon showText={false} style="ghost" sizePadding="firstDegree" />
            </SheetTrigger>
            <SheetContent>
                <SheetHeader
                    title="consultants.statement.billsDetails.newBill"
                    subheader="global.information.allFieldsMandatory"
                />
                <SheetSlot className="flex relative">
                    <FormEditBills
                        onSubmit={handleSubmit}
                        submitRef={submitRef}
                        global={global}
                        submissionSuccess={submissionSuccess}
                        submissionError={submissionError}
                        disabledDeletion
                    />
                    {loadingAdd && <span className='loader' />}
                    {errorAdd && <PrintErrorMessage error={errorAdd} />}
                </SheetSlot>
                <SheetFooter
                    buttonDressedText="global.actions.save"
                    onClickDressed={() => submitRef.current?.click()}
                />
            </SheetContent>
        </Sheet>
    );
}
